<template>
  <MenuItem :data="diagnosisList" header="Sensor"/>
</template>
<script>
import MenuItem from './components/MenuItem';
import { modelOpenRouter } from '@/mixins/model-open';
export default {
  name: 'DiagnosisSensor',
  mixins: [modelOpenRouter],
  components: {
    MenuItem
  },
  data () {
    return {
      diagnosisList: [
        {
          id: 'diagnosisSpeedSensor',
          img: 'item_part_speed_sensor.png',
          item: 'Speed Sensor',
          path: ''
        },
        {
          id: 'diagnosisCadenceSensor',
          img: 'item_part_cadence_sensor.png',
          item: 'Cadence Sensor',
          path: ''
        },
        {
          id: 'diagnosisTorqueSensor',
          img: 'item_part_torque_sensor.png',
          item: 'Torque Sensor',
          path: ''
        },
        {
          id: 'diagnosisBack',
          img: 'item_back.png',
          item: 'Back',
          path: '/service-tools/diagnosis'
        },
        {
          id: 'diagnosisFinishAndCreateReport',
          img: 'item_confirm.png',
          item: 'Finish and Create Report',
          path: 'confirm'
        }
      ]
    };
  }
};
</script>
<style lang="scss" scoped>
</style>
